import { render, staticRenderFns } from "./HomeTeaser.vue?vue&type=template&id=3d3670bb&scoped=true"
import script from "./HomeTeaser.vue?vue&type=script&lang=js"
export * from "./HomeTeaser.vue?vue&type=script&lang=js"
import style0 from "./HomeTeaser.vue?vue&type=style&index=0&id=3d3670bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3670bb",
  null
  
)

export default component.exports